import {
  Box,
  Rating,
  Stack,
  Typography,
  Divider,
} from "@mui/material";
import { useParams } from "react-router-dom";
import { useGetTalentByIdQuery } from "../../services/talent.service";
import { useTitle } from "../../hooks/useTitle";
import { useGetTalentReviewsQuery } from "../../services/review.service";
import dayjs from "dayjs";
import { CardBase, OrangeLinearProgress } from "../../components/global";

const TalentReviewsPage = () => {
  const { talentId } = useParams();

  const { data: talent } = useGetTalentByIdQuery(parseInt(talentId!), {
    skip: !talentId,
  });

  const { data, isLoading, isFetching } = useGetTalentReviewsQuery(
    parseInt(talentId!),
    {
      skip: !talentId,
    }
  );

  useTitle(
    `Talent #${talent?.id}`,
    `${talent?.first_name} ${talent?.last_name} | Talent`
  );

  return (
    <Box>
      <CardBase
        title={`Reviews For ${talent?.full_name || ""}`}
        useGlassCard={false}
        sx={{ mb: 3 }}
      >
        {(isLoading || isFetching) && <OrangeLinearProgress sx={{ mb: 2 }} />}
        {!isLoading && !isFetching && (!data || data?.length == 0) && (
          <Typography variant="body2" sx={{ color: "text.disabled", py: 2 }}>
            No Review, Yet
          </Typography>
        )}
      </CardBase>
      {data?.map((review) => (
        <CardBase
          key={review.id}
          useGlassCard={false}
          sx={{ mb: 2 }}
        >
          <Stack direction="column" spacing={2}>
            <Box>
              <Typography
                variant="h6"
                sx={{
                  color: "#F4A259",
                  fontWeight: 600,
                  mb: 0.5,
                }}
              >
                #{review.project?.id} {review?.project?.title}
              </Typography>
              <Typography variant="body2" sx={{ color: "text.secondary" }}>
                {review.project?.company?.name || "n/a"}
              </Typography>
            </Box>
            <Divider />
            <Stack direction="column" spacing={1}>
              <Rating value={review.star} readOnly={true} size="small" />
              <Typography
                variant="body2"
                sx={{
                  fontStyle: "italic",
                  color: "text.primary",
                  whiteSpace: "pre-wrap",
                }}
              >
                {review.review}
              </Typography>
              <Typography
                variant="caption"
                sx={{ color: "text.disabled", mt: 1 }}
              >
                {dayjs(review.created_at).format("MMM DD, YYYY hh:mm A")}
              </Typography>
            </Stack>
          </Stack>
        </CardBase>
      ))}
    </Box>
  );
};
export default TalentReviewsPage;
